<template>
  <div class="colorWhite">
    <div class="displayInLineBlock pl-5">
      <h3>{{$store.getters.title}} / {{$store.getters.subtitle}}</h3>
    </div>
    <div style="float: right;">
      <div style="width:525px;">
        <b>{{employee_name}}</b>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: { employee_name() { return this.session.user? this.session.user.employee_name: '' } },
};
</script>
